/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useExpanded, useGroupBy, usePagination, useSortBy, useTable } from 'react-table';
import styled from 'styled-components';
import CustomTablePagination from './CustomTablePagination';
import EmptyTable from './EmptyTable';
import DataTable from './DataTable';

const Styles = styled.div`
  flex-direction: column;
  height: calc(100% - 60px);
  width: 100%;

  td {
    padding-bottom: 0;
  }

  .MuiTableCell-stickyHeader {
    box-shadow: 0 5px 6px -2px rgba(0, 0, 0, 0.15);
    background-color: #f5f5f5;
  }
`;

function EnhancedTable({
  className,
  columns = [],
  data,
  pivotBy,
  pageSizeOptions,
  defaultPageSize,
  style = {},
}) {
  const {
    getTableProps,
    headerGroups,
    prepareRow,
    page,
    gotoPage,
    setPageSize,
    state: { pageIndex, pageSize },
    toggleAllRowsExpanded,
    rows,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        groupBy: pivotBy,
        pageSize: defaultPageSize,
      },
      expandSubRows: false,
    },
    useGroupBy,
    useSortBy,
    useExpanded,
    usePagination
  );

  useEffect(() => {
    toggleAllRowsExpanded(false);
  }, [pageIndex, pageSize]);

  // нужно для того чтобы, фиксировался минимальный размер таблицы и при переключении страниц размер не должен меняться.
  // меняется только при изменении количества отображаемых строк.
  const [minHeight, setMinHeight] = useState(0);

  const ref = useRef(null);
  useEffect(() => {
    if (!!ref.current && ref.current.clientHeight > minHeight) {
      setMinHeight(ref.current.clientHeight);
    }
  }, [ref.current, minHeight, pageIndex]);

  return (
    <div style={{ ...style }} className={className}>
      <Styles ref={ref} style={{ minHeight }} className={!!page.length && 'scroll'}>
        {page.length === 0 ? (
          <EmptyTable />
        ) : (
          <DataTable
            headerGroups={headerGroups}
            prepareRow={prepareRow}
            page={page}
            getTableProps={getTableProps}
            columns={columns}
          />
        )}
      </Styles>
      <CustomTablePagination
        rows={rows}
        pageSizeOptions={pageSizeOptions}
        pageSize={pageSize}
        pageIndex={pageIndex}
        gotoPage={gotoPage}
        setPageSize={setPageSize}
        setMinHeight={setMinHeight}
      />
    </div>
  );
}

export default EnhancedTable;
